import React from "react";
import * as Styles from "./style/TradeInAemModelPriceStyles";
import type { PriceType } from "../../../../../common-deprecated/types/CommonTypes";
import {
    formatAEMCashPrice,
    getAemPriceConfig,
} from "../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { useTradeInAemSelector } from "../../../../redux/store";

type ModelResultCashPriceType = {
    price: PriceType;
    modelCode?: string;
};
const TradeInAemModelCashPrice = (props: ModelResultCashPriceType): JSX.Element | null => {
    const { price, modelCode = "" } = props;
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);

    const priceConfig = getAemPriceConfig(commonSettings, AemFmComponent.ModelFilter, modelCode);
    const formattedDiscount = formatAEMCashPrice(
        price.discount,
        commonSettings.culture.name,
        priceConfig,
        price.licenseFee,
    );

    return (
        <Styles.Cash>
            <span dangerouslySetInnerHTML={{ __html: formattedDiscount }} />
        </Styles.Cash>
    );
};

export default TradeInAemModelCashPrice;
